import { getBanner, getNews1,getNews2,getActivity,getFlinks,getSupport,getMuseum } from '@/api/index'

let locale;
localStorage.getItem('locale') ? locale = localStorage.getItem('locale') : locale = 'en';

const getQueryVariable = function (variable){
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] === variable){return pair[1];}
      }
      return(false);
}
if(getQueryVariable('type')==='en'||getQueryVariable('type')==='ennews'){
  locale = 'en';
  localStorage.setItem('locale',locale);
}

const state = {
  banner:[],
  news1:[],
  news2:[],
  activity:[],
  lang:locale,
  flinks:[],
  support:[],
  museum:[]
}

const mutations = {
  setBanner: (state, b) => {
    state.banner = b;
  },
  setNews1: (state, n) => {
    state.news1 = n;
  },
  setNews2: (state, n) => {
    state.news2 = n;
  },
  setActivity: (state, n) => {
    state.activity = n;
  },
  setLang: (state, n) => {
    state.lang = n;
  },
  setFlinks: (state, n) => {
    state.flinks = n;
  },
  setSupport: (state, n) => {
    state.support = n;
  },
  setMuseum: (state, n) => {
    state.museum = n;
  }
}

const actions = {
  getBanner({ commit }){
    return new Promise((resolve, reject) => {
      getBanner().then(res=>{
        commit('setBanner',res)
        resolve(res);
      });
    }) 
  },
  getNews1({ commit }){
    return new Promise((resolve, reject) => {
      getNews1().then(res=>{
        console.log(res);
        commit('setNews1',res)
        resolve(res);
      });
    }) 
  },
  getNews2({ commit }){
    getNews2().then(res=>{
      commit('setNews2',res)
    });
  },
  getActivity({ commit }){
    getActivity().then(res=>{
      // console.log(res);
      commit('setActivity',res)
    });
  },
  getFlinks({ commit }){
    getFlinks().then(res=>{
      commit('setFlinks',res)
    });
  },
  getSupport({ commit }){
    getSupport().then(res=>{
      console.log(res);
      commit('setSupport',res)
    });
  },
  getMuseum({ commit }){
    getMuseum().then(res=>{
      commit('setMuseum',res);
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

